/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { uniqueID } from '../../utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { getOrderDetail } from '../../store/reducers/order';
import qs from 'qs';
import { axiosInstance, encodeValue, formatRupiah, sendAnalyticsPageView, sendAnalyticsCustomEvent, trackMetaPixelEvent, authHeaders } from '../../utils/helper';
import Loader from '../../components/Loader';
import { ListPaymentMethodAll } from '../../utils/constants';
import { CardlessWithdrawalIcon, UltraVoucherIcon } from '../../utils/svg';
import useNavigation from '../../hook/useNavigation';

const Success = () => {
  const navigate = useNavigation();
  	const dispatch = useDispatch();
	const customerID = useSelector((store) => store.user?.customerID);
	const location = useLocation();
	const { payment } = location?.state ?? {};
	const orderDetails = useSelector((state) => state.order?.detail);

	const user = useSelector((store) => store?.user);
	const [isLoading, setIsLoading] = useState(false);
	const [orderNumber, setOrderNumber] = useState(null);

	const handleGetOrderId = async () => {
		if (!payment?.order_id && !payment?.reference_no) return;
		console.log('handleGetOrderId');
		try {
			setIsLoading(true);
			const postData = {
				paymentReferenceID: payment?.order_id || payment?.reference_no,
			};
			const res = await axiosInstance.post(`get-order-number`, qs.stringify(postData), authHeaders());
			if (res?.data?.status === 'ok') {
				const orderNumber = res?.data?.data?.orderNumber;
				setOrderNumber(orderNumber);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

  useEffect(() => {
    sendAnalyticsPageView("payment_success_session");
  }, []);

  useEffect(() => {
		if(!orderNumber || !payment) return;

		dispatch(getOrderDetail({ 
			unquieid: uniqueID, 
			customerID: encodeValue(customerID),
			orderNumber: orderNumber 
		}));

		if(orderDetails?.orderNumber !== orderNumber) return;

		const detail_order_items = [
			{
				purchased_on: orderDetails.order_date,
				status: payment?.status,
				merchants_name: orderDetails?.orderItems?.[0]?.storeName,
				product: orderDetails?.orderItems?.[0]?.items,
				payment_id: payment?.payment_category?.[0]?.payment_method?.[0]?.name,
				value: payment?.total_amount,
			}
		];

		sendAnalyticsCustomEvent('history_detail_order', {
			order_id: orderNumber,
			detail_order_items
		});
		trackMetaPixelEvent('history_detail_order', {
			order_id: orderNumber,
			detail_order_items
		});
	}, [orderNumber])


	useEffect(() => {
    // react-hooks/exhaustive-deps
		handleGetOrderId();
	}, [payment?.order_id]);

	const handleRemoveCart = async () => {
		console.log('handleRemoveCart');
		try {
			const postData = {
				unquieid: uniqueID,
				customerID: encodeValue(user?.customerID),
			};
			const res = await axiosInstance.post(`cart/removeCart`, qs.stringify(postData), authHeaders());
			return res;
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleOrderAgain = async (item) => {
		console.log('handleOrderAgain');
		try {
			const removeCart = await handleRemoveCart();
			console.log('removeCart: ');
			if (removeCart?.data?.status !== 'ok') {
				return;
			}
			const postData = {
				unquieid: uniqueID,
				customerID: encodeValue(user?.customerID),
				orderID: encodeValue(orderNumber),
			};
			const res = await axiosInstance.post(`orders/orderAgain`, qs.stringify(postData));
			console.log('res: ', res);
			if (res?.data?.status === 'ok') {
				navigate.push('/summary', {}, true);
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleBackToHome = () => {
		navigate.push('/', {}, true);
	};

	const handleCheckOrder = () => {
		navigate.push(`/history/all/${orderNumber}`, {}, true);
	};

	const paymentMethod = useMemo(() => {
		if (!ListPaymentMethodAll?.length || !payment) return '';
		return ListPaymentMethodAll?.find((paymentMethod) => {
			const paymentCode = paymentMethod?.code?.toLowerCase();
      const paymentName = paymentMethod?.name?.toLowerCase();
			return paymentCode === payment?.payment_category?.[0]?.payment_method?.[0]?.code?.toLowerCase() || paymentCode === payment?.payment_category?.payment_method?.[0]?.code?.toLowerCase() || paymentCode === payment?.payment_method?.toLowerCase() || paymentName === payment?.payment_method?.toLowerCase();
		});
	}, [ListPaymentMethodAll, payment]);

  return (
		<>
			{isLoading && <Loader overlay />}
			<div className='h-screen w-full flex justify-center items-center bg-white'>
				<div className='relative h-screen w-full max-w-lg flex items-center'>
					<div className='flex flex-col justify-center items-center w-full mx-4'>
            <CardlessWithdrawalIcon className='w-44 h-auto object-contain object-center fill-[var(--rose-violet)] pb-2' />
						<div className='text-xl font-bold text-gray-600 text-center'>
						  Selamat,
							<br />
							pembayaran Anda berhasil
						</div>
						<div className='text-sm text-gray-400 text-center mt-4'>
              Pembayaran Anda telah berhasil diverifikasi.
							<br />
							Terima kasih telah berbelanja di UFood
						</div>
						<div className='mt-5 w-full border border-gray-300 border-solid rounded-lg p-4'>
							<div className='flex justify-between items-center'>
								<div className='flex flex-col items-center'>
									<span className='text-sm text-gray-400'>Total Pembayaran</span>
									<div className='text-lg font-semibold text-gray-600'>{formatRupiah(payment?.total_amount ?? 0)}</div>
								</div>
								<button
                  id='payment_success_view_detail'
									disabled={!orderNumber}
									onClick={handleCheckOrder}
									className={`text-sm border-1 border-solid ${
										!orderNumber ? 'bg-gray-400 border-gray-400 text-white' : 'bg-white border-[var(--rose-violet)] text-[var(--rose-violet)]'
									} px-4 py-1.5 rounded-md font-semibold`}>
									Lihat Pesanan
								</button>
							</div>
							<div className='border-b-1 border-solid pb-2 border-gray-200 my-2 -mx-4' />
							<div className='text-sm text-gray-400 pt-2'>Metode Pembayaran</div>
							<div className='flex items-center mt-2'>
								{paymentMethod?.code === 'ULTRA-VOUCHER' ? (
									<UltraVoucherIcon />
								) : (
									<img src={paymentMethod?.image_url} alt={paymentMethod?.code} className={`${paymentMethod?.image_size_payment ?? 'w-12'} h-auto`} />
								)}
								<div className='pl-2 text-base font-semibold text-gray-700'>{paymentMethod?.name ?? ''}</div>
							</div>
						</div>
						<button
              id='payment_success_reorder'
							disabled={!orderNumber}
							onClick={handleOrderAgain}
							className={`hidden mt-5 w-full py-2.5 rounded-lg text-white text-base font-semibold ${!orderNumber ? 'bg-gray-400 border-gray-400' : 'bg-[var(--rose-violet)] border-[var(--rose-violet)]'} `}>
							Pesan Lagi
						</button>
						<button onClick={handleBackToHome} className='mt-4 w-full py-2.5 rounded-lg border-1 border-solid border-[var(--rose-violet)] bg-white text-base font-semibold text-[var(--rose-violet)]' id='payment_success_back_to_home'>
							Kembali ke Beranda
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

export default Success;
